var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectricalPlug(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 50,
    viewBox: "0 0 28 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2312_20831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.614022 15.058H26.9952C27.3194 15.058 27.6093 15.3309 27.6093 15.6719V17.7353C27.6093 18.0765 27.3194 18.3491 26.9952 18.3491H0.614022C0.272942 18.3491 0 18.0765 0 17.7353V15.6719C0 15.3309 0.272942 15.058 0.614022 15.058Z",
    fill: "#535E64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.614037 15.0581H5.64476C5.423 15.0581 5.25245 15.331 5.25245 15.672C5.25245 16.3712 5.25245 17.0533 5.25245 17.7354C5.25245 18.0765 5.423 18.3494 5.64476 18.3494H0.614037C0.272964 18.3494 0 18.0765 0 17.7354V15.672C0 15.331 0.272964 15.0581 0.614037 15.0581Z",
    fill: "#424E54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36426 18.3492C9.65214 18.3492 17.9401 18.3492 26.2448 18.3492C26.2448 23.1411 26.2448 21.5383 26.2448 25.2049C26.2448 29.5191 19.4406 32.1283 18.8438 36.2041V38.762C18.8438 39.6999 18.0595 40.4844 17.1214 40.4844H10.4876C9.53278 40.4844 8.76532 39.6999 8.76532 38.762V36.2041C8.15142 32.1283 1.36426 29.5191 1.36426 25.2049C1.36426 21.5383 1.36426 23.1411 1.36426 18.3492Z",
    fill: "#40494D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36426 18.3493H5.50814C5.50814 23.1412 5.50814 21.5382 5.50814 25.2048C5.50814 29.5193 10.0444 32.1282 10.4365 36.2041C10.4365 37.0567 10.4365 37.9093 10.4365 38.762C10.4365 39.6999 10.9652 40.4844 11.5792 40.4844H10.4877C9.53284 40.4844 8.76529 39.6999 8.76529 38.762V36.2041C8.15149 32.1282 1.36426 29.5193 1.36426 25.2048C1.36426 21.5382 1.36426 23.1412 1.36426 18.3493Z",
    fill: "#31383D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73732 22.3739H17.8548C18.0082 22.3739 18.1106 22.4761 18.1106 22.6125V23.2777C18.1106 23.4141 18.0082 23.5333 17.8548 23.5333H9.73732C9.6009 23.5333 9.48169 23.4141 9.48169 23.2777V22.6125C9.48169 22.4761 9.6009 22.3739 9.73732 22.3739ZM9.73732 27.2167H17.8548C18.0082 27.2167 18.1106 27.3364 18.1106 27.4728V28.1377C18.1106 28.2741 18.0082 28.3936 17.8548 28.3936H9.73732C9.6009 28.3936 9.48169 28.2741 9.48169 28.1377V27.4728C9.48169 27.3364 9.6009 27.2167 9.73732 27.2167ZM9.73732 24.7953C12.4488 24.7953 15.1603 24.7953 17.8548 24.7953C18.0082 24.7953 18.1106 24.9147 18.1106 25.0512C18.1106 25.2728 18.1106 25.4944 18.1106 25.7161C18.1106 25.8527 18.0082 25.9549 17.8548 25.9549C15.1603 25.9549 12.4488 25.9549 9.73732 25.9549C9.6009 25.9549 9.48169 25.8527 9.48169 25.7161C9.48169 25.4944 9.48169 25.2728 9.48169 25.0512C9.48169 24.9147 9.6009 24.7953 9.73732 24.7953Z",
    fill: "#31383D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36426 18.3492H26.2448V19.4578H1.36426V18.3492Z",
    fill: "#31383D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0786 36.0676H16.8657C17.0703 36.0676 17.2409 36.238 17.2409 36.4598C17.2409 36.6644 17.0703 36.835 16.8657 36.835H10.0786C9.87398 36.835 9.70337 36.6644 9.70337 36.4598C9.70337 36.238 9.87398 36.0676 10.0786 36.0676Z",
    fill: "#31383D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9373 40.4843H15.655V50H11.9373V40.4843Z",
    fill: "#7A8E97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4748 1.53501H20.7709V4.96254H19.4748V1.53501ZM19.1338 0.000107765H21.129C21.5896 0.000107765 21.9818 0.392263 21.9818 0.869942V15.0581H18.2639V0.869942C18.2639 0.392263 18.6565 0.000107765 19.1338 0.000107765ZM6.82146 1.53501H8.13445V4.96254H6.82146V1.53501ZM6.48024 0.000107765H8.47554C8.95301 0.000107765 9.32823 0.392263 9.32823 0.869942V15.0581H5.62769V0.869942C5.62769 0.392263 6.00291 0.000107765 6.48024 0.000107765Z",
    fill: "#A4B1B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9818 13.9834H18.264V15.0579H21.9818V13.9834ZM9.3281 13.9834V15.0579H5.62769V13.9834H9.3281Z",
    fill: "#8F9EA2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9373 40.4843H15.655V42.1555H11.9373V40.4843Z",
    fill: "#657C85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2312_20831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6094,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalPlug);
export default __webpack_public_path__ + "static/media/electricalPlug.9339336dbc601643cea1fb1960838e7d.svg";
export { ForwardRef as ReactComponent };